import React from "react";
import styles from "./InputText.module.css";

function InputText({
  value,
  onChange,
  className = "",
  placeholder = "",
  type = "text",
  autofocus = false,
  variant = "",
  ...rest
}) {
  const validVariants = ["light", "dark", "modal"];
  const safeVariant = validVariants.includes(variant) ? variant : "dark";

  const combinedClassName =
    `${styles.input} ${styles[safeVariant]} ${className}`.trim();

  return (
    <input
      className={combinedClassName}
      autoFocus={autofocus}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      {...rest}
    />
  );
}

export default InputText;
